<template>
<div id="app">

  <section class="hero is-fullheight is-default is-bold">
      <div class="hero-head">
          <nav class="navbar">
              <div class="container">
                  <div>
                    <a href="/">
                      <p class="title">Clean your repos</p>
                      <p class="subtitle">Quickly check which repo needs some love</p>
                    </a>
                  </div>
                  <div id="navbarMenu" class="navbar-menu">
                      <div class="navbar-end">
                          <div class="tabs is-right">
                              <ul>
                                  <li><a @click="about">About</a></li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
          </nav>
      </div>
      <div class="hero-body">
          <div class="container has-text-centered">
              <div class="is-vcentered">
                <section>
                  <div class="columns is-centered">
                    <div class="column is-half">
                        <b-field label="Github Username" label-position="on-border">
                          <b-input @keyup.native.enter="fetchData" size="is-large" v-model="username"></b-input>
                        </b-field>
                        <b-button size="is-large" @click="fetchData">Go</b-button>
                                        <br><br>
                                        <a href="http://twitter.com/share?text=Clean your repos: Quickly check which of your @github repos need some love&amp;url=http://vitomd.com/kyr&amp;hashtags=github&amp;via=vitomd"
                                        onclick="window.open(this.href, 'twitter-share', 'width=550,height=235');return false;">Share on Twitter</a>
                    </div>
                  </div>
                </section>

                <b-table :data="repos"
                  :narrowed="true"
                  :striped="true"
                  :loading="isLoading"
                  :default-sort="['warnings', 'desc']">
                  <template slot-scope="props">
                    <b-table-column field="name" label="Name" sortable>
                      <a :href="props.row.url">{{props.row.name}} </a>
                    </b-table-column>


                    <b-table-column field="created_at" label="Created" centered sortable :custom-sort="sortCreated">
                        <span class="tag">
                          {{ props.row.created_at.toLocaleDateString() }}
                        </span>
                    </b-table-column>

                    <!-- <b-table-column field="forks_count" label="Forks" sortable numeric>
                      {{props.row.forks_count}}
                    </b-table-column> -->

                    <b-table-column field="stars" label="Stars" sortable numeric>
                      {{props.row.stars}}
                    </b-table-column>

                    <b-table-column field="description" label="Description">
                      <span :class="[(props.row.description) ? '' : 'tag is-danger']">
                        {{props.row.description ? props.row.description : 'Empty'}}
                      </span>
                    </b-table-column>

                    <b-table-column width="50 "field="topics" centered label="Topics">
                      <span style="word-break:break-all; white-space:normal; height: auto" :class="[(props.row.topics) ? 'tag is-success' : ' tag is-danger']">
                        {{props.row.topics ? props.row.topics : 'Empty'}}
                      </span>
                    </b-table-column>

                    <b-table-column field="license" label="License" centered sortable>
                      <span :class="[(props.row.license != ' ') ? 'tag is-success' : 'tag is-danger']">
                        {{props.row.license != ' ' ? props.row.license : 'Empty'}}
                      </span>
                    </b-table-column>

                    <b-table-column field="open_issues_count" label="Issues" centered sortable numeric>
                      <span :class="[(props.row.open_issues_count > 0) ? 'tag is-danger' : 'tag is-success']">
                        {{props.row.open_issues_count}}
                      </span>
                    </b-table-column>

                    <b-table-column field="pushed_at" label="Last push" centered sortable :custom-sort="sortPushed">
                        <span :class="[isOld(props.row.pushed_at) ? 'tag is-danger' : 'tag is-success']">
                          {{ props.row.pushed_at.toLocaleDateString() }}
                        </span>
                    </b-table-column>
                    <b-table-column field="warnings" label="Warnings" sortable numeric>
                      <span :class="[(props.row.warnings > 0) ? 'tag is-danger' : 'tag is-success']">
                        {{props.row.warnings}}
                      </span>
                    </b-table-column>
                  </template>

                </b-table>
              </div>
          </div>
      </div>

      <div class="hero-foot">
          <div class="container">
              <div class="has-text-centered" style="padding-bottom:20px">
                  <a href="http://vitomd.com">Created by vitoMd</a>
              </div>
          </div>
      </div>
  </section>
</div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      username: '',
      repos: [],
      data: null,
      isLoading: false,
    }
  },
  methods: {
    //TODO: Use graphql api
    fetchData: function() {
      let apiURL = `https://api.github.com/users/${this.username}/repos`
      var xhr = new XMLHttpRequest()
      var self = this
      self.isLoading = true
      xhr.open('GET', apiURL)
      xhr.setRequestHeader('Accept', 'application/vnd.github.mercy-preview+json');
      xhr.onload = function() {
        let data = JSON.parse(xhr.responseText)
        self.repos = []
        data.forEach((repoData, index) => {
          let rowData = {
            name: repoData.name,
            description: repoData.description,
            url: repoData.html_url,
            created_at: new Date(repoData.created_at),
            pushed_at: new Date(repoData.pushed_at),
            forks_count: repoData.forks_count,
            stars: repoData.stargazers_count,
            topics: repoData.topics.join(', '),
            license: repoData.license ? repoData.license.key : ' ',
            open_issues_count: repoData.open_issues_count,

            private: repoData.private,
            fork: repoData.fork,
            archived: repoData.archived,
            disabled: repoData.disabled,
            warnings: 0
          }
          if (!rowData.private && !rowData.fork && !rowData.archived && !rowData.disabled) {
            rowData.warnings = self.countWarnings(rowData)
            self.repos.push(rowData)
          }
        });
        self.isLoading = false
      }
      xhr.send()
    },
    about() {
      this.$dialog.alert({
        title: 'About',
        message: 'This tool will search your public Github repositories and check for last push, missing license, description, topics, open issues. <br> Have some new ideas?, Tweet me at <a href="http://twitter.com/vitomd">@vitomd</a>. <br> Are you an organization? Soon it will be on the marketplace ',
        confirmText: 'Ok'
      })
    },
    isOld(pushed_date) {
      let currentDate = new Date()
      let yearAgo = new Date().setFullYear(currentDate.getFullYear()-1)
      return (pushed_date < yearAgo)
    },
    //TODO Clean , improve those methods
    sortPushed(a, b, isAsc) {
      if (isAsc) {
        return  b.pushed_at.getTime() - a.pushed_at.getTime();
      } else {
        return  a.pushed_at.getTime() - b.pushed_at.getTime();
      }
    },
    sortCreated(a, b, isAsc) {
      if (isAsc) {
        return b.created_at.getTime() - a.created_at.getTime();
      } else {
        return a.created_at.getTime() - b.created_at.getTime();
      }
    },
    countWarnings(rowData) {
      let warnings = 0
      if (rowData.topics == '') 
        warnings++
      if (rowData.license == ' ')
        warnings++
      if (rowData.open_issues_count > 0)
        warnings++
      if (this.isOld(rowData.pushed_at))
        warnings++
      return warnings
    }
  }
}
</script>

<style>
  .is-large.input {
    font-size: 2.5rem
  }
</style>



// WEBPACK FOOTER //
// src/App.vue